const NEEDS_QUOTING_PATTERN = /[",\n\r]/;
const FORMULA_PREFIX_PATTERN = /^[=+\-@]/;

export const escapeCsvField = (value: string): string => {
  if (NEEDS_QUOTING_PATTERN.test(value) || FORMULA_PREFIX_PATTERN.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};
